import React from 'react';
import Health from 'components/Shared/Debug/Health/container';

const HealthPage = () => <Health />;

export default HealthPage;
